import React from "react";
import ReactApexChart from "react-apexcharts";

export default function CollectionChart() {
  const state = {
    series: [
      {
        name: "Total",
        data: [76, 85, 101, 89, 56],
      },
      {
        name: "Open",
        data: [44, 55, 57, 18, 16],
      },
      {
        name: "In Route",
        data: [35, 41, 36, 56, 35],
      },
      {
        name: "Pending",
        data: [15, 31, 26, 9, 6],
      },
      {
        name: "Completed",
        data: [25, 21, 16, 8, 5],
      },
    ],
    options: {
      colors: ["#01372B", "#014C3C", "#016D56", "#4D9989", "#99C5BB"],
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: ["Branch", "Corporate", "Central Bank", "Customer Bank", "Customer2 Bank"],
      },
      legend: {
        position: "top",
      },
      fill: {
        opacity: 1,
      },
      title: {
        text: "Collection services status",
      },
      tooltip: {
        y: {
          formatter (val) {
            return `${val  } orders`;
          },
        },
      },
    },
  };
  return <ReactApexChart options={state.options} series={state.series} type="bar" height={350} />;
}
